/* istanbul ignore file */
export * from './DisplaySettingsDesktop';
